import _ from 'underscore';

export class AdsStudioErrorBase extends Error {
  constructor({
    message,
    originError,
    errorCode,
    errorProcessor, // use processor to extend the error object with anything needed
    ...rest // additional data passed to processor
  }) {
    super(message);
    this.originError = originError;
    this.errorCode = errorCode || (originError && originError.errorCode) || 'Unknown';
    if (errorProcessor) {
      const params = { message, errorCode, ...rest };
      const info = errorProcessor(this.errorCode, params);
      _.extendOwn(this, info);
    }
  }
}
